import { styled } from '@material-ui/core/styles';

export const ResultsContainer = styled('section')({});
